/**
 * Formats a date based on the specified format type
 * @param {Date|string} date - The date to format
 * @param {string} formatType - The format type ('long' or 'iso')
 * @returns {string} The formatted date string
 */
export const formatDate = (date, formatType = 'long') => {
  if (!date) return '';
  
  // Ensure we're working with a Date object
  const dateObj = date instanceof Date ? date : new Date(date);
  
  if (formatType === 'iso') {
    // Format as YYYY-MM-DD for value storage
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } else {
    // Format based on locale for display
    return new Intl.DateTimeFormat(navigator.language, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(dateObj);
  }
};